import style from "./style.module.sass"
import React from "react";
import { useTheme } from "@material-ui/core/styles";
import { Modal } from "@material-ui/core";
import { Close } from "@material-ui/icons"

export default function ErrorModal({ error, setShowLoadText, setError }) {
  const { theme: { bgColors, colors } } = useTheme()

  return error ? (
    <Modal open={!!error} onClose={() => {
      setError(null);
      // setShowLoadText(false);
    }}>
      <div className={`${style.mainCont} ${!!error && style.open} pb-3`}
        style={{ backgroundColor: bgColors.bgPrimary0 }}>
        <div className={`${style.head} d-flex justify-content-between p-1 pl-3`} style={{backgroundColor: bgColors.bgStatusError}}>
          <p className={`m-0 ${style.title}`} style={{ color: colors.colorTextReverse }} >{error.header}</p>
          <button className={`border-0 bg-transparent`} onClick={() => {
            setError(null);
            // setShowLoadText(false);
          }}>
            <Close style={{ fill: colors.colorTextReverse, fontSize: '1.3rem' }} />
          </button>
        </div>
        <p className={`${style.descText} mt-2 m-0 pr-3 pl-3`} style={{ color: colors.colorText}}>
          {error.text}
        </p>
      </div>
    </Modal>
  ) : null
}
